import snakify from "snakify-ts";
import { CustomerGroupBodySchema, DefaultService } from "../generated";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import camelize, { Camelize } from "camelize-ts";
import { toaster } from "../components/toaster";
import { useNavigate } from "react-router-dom";

export const useCustomerGroup = (groupUuid?: string) => {
  return useQuery({
    queryKey: ["customerGroup", groupUuid],
    queryFn: () =>
      DefaultService.fakturCustomersViewsGroup({ groupUuid: groupUuid || "" }),
    select: (data) => camelize(data),
    enabled: Boolean(groupUuid),
  });
};

export const useCustomerGroupList = () => {
  return useQuery({
    queryKey: ["customerGroupList"],
    queryFn: DefaultService.fakturCustomersViewsGroupList,
    select: (data) => camelize(data),
  });
};

export const useCustomerGroupCreate = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationKey: ["customerGroupCreate"],
    mutationFn: (data: Camelize<CustomerGroupBodySchema>) =>
      DefaultService.fakturCustomersViewsGroupCreate({
        requestBody: snakify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customerGroupList"] });
      toaster.success({ title: "Kundegruppe opprettet!" });
      navigate("/customers/groups/");
    },
  });
};

export const useCustomerGroupUpdate = (groupUuid?: string | null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["customerGroupUpdate"],
    mutationFn: (data: Camelize<CustomerGroupBodySchema>) =>
      DefaultService.fakturCustomersViewsGroupUpdate({
        groupUuid: groupUuid || "",
        requestBody: snakify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customerGroupList"] });
      toaster.success({ title: "Kundegruppe oppdatert!" });
    },
  });
};

export const useCustomerGroupDelete = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["customerGroupDelete"],
    mutationFn: ({ groupUuid }: { groupUuid: string }) =>
      DefaultService.fakturCustomersViewsGroupDelete({ groupUuid }),
    onSuccess: () => {
      toaster.success({ title: "Kundegruppe slettet!" });
      queryClient.invalidateQueries({ queryKey: ["customerGroupList"] });
      queryClient.invalidateQueries({ queryKey: ["customerGroup"] });
      navigate("/customers/groups/");
    },
  });
};
